var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcAirportShuttle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 12.727,
    viewBox: "0 0 20 12.727",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #25556e;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "ic_airport_shuttle_24px",
    className: "cls-1",
    d: "M15.545,5H2.818A1.818,1.818,0,0,0,1,6.818V15H2.818a2.727,2.727,0,0,0,5.455,0h5a2.727,2.727,0,0,0,5.455,0H21V10.455Zm-10,11.364A1.364,1.364,0,1,1,6.909,15,1.362,1.362,0,0,1,5.545,16.364Zm10.455,0A1.364,1.364,0,1,1,17.364,15,1.362,1.362,0,0,1,16,16.364Zm-2.273-5.909V6.818h.909l3.636,3.636Z",
    transform: "translate(-1 -5)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAirportShuttle);
export default __webpack_public_path__ + "static/media/ic_airport_shuttle.f7020ff5410c1bd8d2bceeec65c6a7a0.svg";
export { ForwardRef as ReactComponent };